export const SERVER_URL = 'https://twitee-by-devugo.herokuapp.com/';
